import React from "react";
import { BrowserRouter, Route, Switch, Redirect, Router } from "react-router-dom";
import { createBrowserHistory } from "history";

import ScrollToTop from "../hoc/ScrollToTop";
import ReviewDownload from "./MainContent/DownloadAndDelete/ReviewDownload/ReviewDownload";
import MultifactorAuthentication from "./MainContent/DownloadAndDelete/MultifactorAuthentication/MultifactorAuthentication";
import MultifactorAuthenticationPrimer from "./MainContent/DownloadAndDelete/MultifactorAuthentication/MultifactorAuthenticationPrimer";
import DownloadAmount from "./MainContent/DownloadAndDelete/DownloadAmount/DownloadAmount";
import DeviceSelection from "./MainContent/DownloadAndDelete/DeviceSelection/DeviceSelection";
import AffidavitPrimer from "./MainContent/DownloadAndDelete/AffidavitPages/AffidavitPrimer";
import AffidavitConfirmation from "./MainContent/DownloadAndDelete/AffidavitPages/AffidavitConfirmation";
import SelectDownloadCategories from "./MainContent/DownloadAndDelete/SelectDownloadCategories/SelectDownloadCategories";
import CVASelectDownloadCategories from "./MainContent/DownloadAndDelete/SelectDownloadCategories/CVASelectDownloadCategories";
import UniversalLanding from "./MainContent/UniversalLanding/UniversalLanding";
import DeleteLineSelection from "./MainContent/DownloadAndDelete/DeleteContainer/DeleteLineSelection";
import DeleteReview from "./MainContent/DownloadAndDelete/DeleteContainer/DeleteReview";
import DeleteInformation from "./MainContent/DownloadAndDelete/DeleteContainer/DeleteInformation";
import DeleteSuccess from "./MainContent/DownloadAndDelete/DeleteContainer/DeleteSuccess";
import DeleteInformationMember from "./MainContent/DownloadAndDelete/DeleteContainer/DeleteInformationMember";
import DownloadStatus from "./MainContent/DownloadAndDelete/DownloadStatus/DownloadStatus";
import RequestHistory from "./MainContent/DownloadAndDelete/RequestHistory/RequestHistory";
import FileFormatSelection from "./MainContent/DownloadAndDelete/FileFormatSelection";
import GuestFlowDownloadInformation from "./MainContent/GuestFlow/GuestFlowDownloadInformation";
import LoginPage from "./MainContent/LoginPage/LoginPage";
import ErrorBoundary from "../hoc/ErrorBoundary";
import NoMatch from "./MainContent/NoMatch/NoMatch";
import ConfirmAuth from "../hoc/ConfirmAuth";
import NavigationHelper from "./MainContent/NavigationHelper/NavigationHelper";

import LoggedInLanding from "./MainContent/LoggedInLanding/LoggedInLanding";
import WirelineLanding from "./MainContent/WirelineFlow/WirelineLanding";
import OTTLanding from "./MainContent/OTT/OTTLanding";
import CVALanding from "./MainContent/CVA/CVALanding";
import FamilyAppLanding from "./MainContent/FamilyApp/FamilyAppLanding";
import { FamilyMoneyLandingPage } from "./MainContent/FamilyMoney";
import GuestFlowLandingNew from "./MainContent/GuestFlow/GuestFlowLandingNew";
import GuestFlowDeleteInfo from "./MainContent/GuestFlow/GuestFlowDeleteInformation"

import DownloadInformation from "./MainContent/DownloadAndDelete/DownloadInformation";
import WirelineDownloadInformation from "./MainContent/WirelineFlow/WirelineDownloadInformation";
import CVADownloadInformation from "./MainContent/CVA/CVADownloadInformation";
import FamilyAppDownloadInformation from "./MainContent/FamilyApp/FamilyAppDownloadInformation";
import OTTDownloadInformation from "./MainContent/OTT/OTTDownloadInformation";
import { FamilyMoneyDownloadInformation } from "./MainContent/FamilyMoney";
import DisconnectedCustomer from "./MainContent/DisconnectedCustomer";
import BECustomer from "./MainContent/BECustomer";
import AccountNotSupported from "./MainContent/AccountNotSupported";
import WirelineSubAccount from "./MainContent/WirelineFlow/WirelineSubAccount";
import MarketingPreferences from "./MainContent/MarketingPreferences";
import EmailNotVerified from "./MainContent/WirelineFlow/EmailNotVerified";
import SMSNotVerified from "./MainContent/WirelineFlow/SMSNotVerified"
import MTNNotVerified from "./MainContent/WirelineFlow/MTNNotVerified"
import { ActionNeeded } from "./MainContent/DownloadAndDelete/ActionNeeded";

import {
  AssignAgentInformation,
  AssignAuthorizedAgent,
  AuthorizedAgentReview,
  AuthorizedAgentSubmitSuccess,
  AuthorizedAgentLanding,
  AuthorizedAgentCustomer,
  AuthorizedAgentNewRequest,
  AuthorizedAgentDeleteInformation,
  ManageAuthorizedAgent,
  AuthorizedAgentDeleteReview,
  AuthorizedAgentDeleteSuccess,
  RenewRemoveAuthAgentSuccess,
  AuthorizedAgentDownloadInformation,
  AuthorizedAgentDownloadAffidavit,
  AuthorizedAgentDownloadReview,
  AuthorizedAgentDownloadSuccess,
  CustomerDownloadStatus as AgentCustomerDownloadStatus,
  AuthorizedAgentSubmitAppeal,
  AuthorizedAgentAppealStatus,
  AuthorizedAgentSubmitProof,
  AuthorizedAgentAppealConfirmation,
  AuthorizedAgentCorrectStatus
} from "./MainContent/AuthorizedAgent";
import CustomerDownloadPasswordPage from "./MainContent/AuthorizedAgent/CustomerDownloadStatus/CustomerDownloadPasswordPage";

import { ResendPasswordSuccess } from "./MainContent/ResendPassword";
import GlobalHelper from "./MainContent/GlobalHelper";
import Timeout from "../hoc/Timeout/Timeout";
import LobWrapper from "../hoc/LobWrapper";

import { ProgressIndicator } from "common-components/ProgressIndicator";
import { BreadCrumbs } from "common-components/BreadCrumbs";

import { ENDPOINTS } from "utils/endpoints";
import { checkAMLob } from "utils/checkAMLob";

import {
  FormerCustomerLandingNew,
  FormerCustomerDownloadInformation,
  VerifyFormerCustomer,
  FormerCustomerDeleteInformation,
  FormerCustomerCorrectionRequestInformation,
  FormerCustomerDeleteOptions,
  FormerCustomerEmailInfo,
  FormerCustomerOTPScreen,
  FormerCustomerFileFormat,
  FormerCustomerDetails,
  FormerCustomerVerifyIdentity,
  FormerCustomerMobileInfo,
  FormerCustomerMobileOTPScreen,
  FormerAndGuestSubmitAppeal,
  FormerAndGuestAppealStatus,
  FormerAndGuestAppealConfirmation
} from "./MainContent/FormerCustomer";
import FormerAndGuestRequestHistory from "./MainContent/FormerCustomer/FormerAndGuestRequestHistory/FormerAndGuestRequestHistory"
import FormerDownloadTimeFrame from "./MainContent/FormerCustomer/FormerDownloadTimeFrame";
import { AccountDisconnected } from "./MainContent/AccountDisconnected";
import { VILSLandingPage, VILSDownloadInformation } from "./MainContent/VILSFlow";

import SubmitAppeal from "./MainContent/DownloadAndDelete/Appeal/SubmitAppeal";
import SubmitProof from "./MainContent/DownloadAndDelete/Appeal/SubmitProof"
import AppealConfirmation from "./MainContent/DownloadAndDelete/Appeal/AppealConfirmation";
import AppealStatus from "./MainContent/DownloadAndDelete/Appeal/AppealStatus";
import CorrectionStatus from "./MainContent/DownloadAndDelete/Correction/CorrectionStatus"

import CorrectibleData from "./MainContent/CorrectibleData";
import FormerCustomerDeleteConfirmation from "./MainContent/FormerCustomer/FormerCustomerDeleteConfirmation";
import CommonDownloadWrapper from "../hoc/CommonDownloadWrapper";
import {
  DownloadEmailAuthentication,
  DownloadOTPAuthentication,
  DownloadVerification,
  DownloadPasswordPage
} from "./MainContent/DownloadAndDelete/DownloadStatus";
import AuthorizedAgentRequestDownload from "./MainContent/AuthorizedAgent/AuthorizedAgentDownloadFlow/AuthorizedAgentRequestDownload";
import AuthorizedAgentFileFormat from "./MainContent/AuthorizedAgent/AuthorizedAgentDownloadFlow/AuthorizedAgentFileFormat";
import AuthorizedAgentAffidavitPrimer from "./MainContent/AuthorizedAgent/AuthorizedAgentDownloadFlow/AuthorizedAgentAffidavitPrimer";


export const history = createBrowserHistory();
const Layout = props => {
  return (
    <BrowserRouter>
      <NavigationHelper />
      <Timeout />
      <Router history={history}>
        <GlobalHelper />
        <ProgressIndicator />
        <BreadCrumbs />
        <ScrollToTop>
          <ErrorBoundary>
            <div style={{ maxWidth: "1272px", margin: "0 auto", position: "relative" }}>
              <Switch>
                <Route
                  exact
                  path="/privacy/your-data/former-customer"
                  component={FormerCustomerLandingNew}
                />

                <Route path="/privacy/your-data/request-history"
                  component={
                    props => (
                      <FormerAndGuestRequestHistory
                        {...props}
                        isNonSecure
                      />
                    )
                  }
                />

                <Route
                  exact
                  path="/privacy/your-data/former-customer/download-information"
                  component={
                    props => (
                      <FormerCustomerDownloadInformation
                        {...props}
                        isNonSecure
                      />
                    )
                  }
                />

                <Route
                  path="/privacy/your-data/(former-customer|guest)/email-info"
                  component={
                    props => (
                      <FormerCustomerEmailInfo
                        {...props}
                        isNonSecure
                      />
                    )
                  }
                />

                <Route
                  path="/privacy/your-data/(former-customer|guest)/otp-auth"
                  component={
                    props => (
                      <FormerCustomerOTPScreen
                        {...props}
                        isNonSecure
                      />
                    )
                  }
                />

                <Route
                  path="/privacy/your-data/(former-customer|guest)/file-format"
                  component={
                    props => (
                      <FormerCustomerFileFormat
                        {...props}
                        isNonSecure
                      />
                    )
                  }
                />

                <Route
                  path="/privacy/your-data/(former-customer|guest)/address_dob"
                  component={
                    props => (
                      <FormerCustomerDetails
                        {...props}
                        isNonSecure
                      />
                    )
                  }
                />

                <Route path="/privacy/your-data/(former-customer|guest)/download-details"
                  component={
                    props => (
                      <FormerDownloadTimeFrame
                        {...props}
                        isNonSecure
                      />
                    )
                  }
                />

                <Route
                  path="/privacy/your-data/(former-customer|guest)/verify-identity"
                  component={
                    props => (
                      <FormerCustomerVerifyIdentity
                        {...props}
                        isNonSecure
                      />
                    )
                  }
                />

                <Route
                  exact
                  path="/privacy/your-data/former-customer/delete"
                  component={
                    props => (
                      <FormerCustomerDeleteInformation
                        {...props}
                        isNonSecure
                      />
                    )
                  }
                />

                <Route
                  exact
                  path="/privacy/your-data/former-customer/deleteOptions"
                  component={
                    props => (
                      <FormerCustomerDeleteOptions
                        {...props}
                        isNonSecure
                      />
                    )
                  }
                />

                <Route
                  path="/privacy/your-data/(former-customer|guest)/verify-customer"
                  component={
                    props => (
                      <VerifyFormerCustomer
                        {...props}
                        isNonSecure
                      />
                    )
                  }
                />

                <Route
                  path="/privacy/your-data/(former-customer|guest)/mobile-info"
                  component={
                    props => (
                      <FormerCustomerMobileInfo
                        {...props}
                        isNonSecure
                      />
                    )
                  }
                />

                <Route
                  path="/privacy/your-data/(former-customer|guest)/mobile-otp-auth"
                  component={
                    props => (
                      <FormerCustomerMobileOTPScreen
                        {...props}
                        isNonSecure
                      />
                    )
                  }
                />
                {/* 22.14 */}
                <Route
                  exact
                  path="/privacy/your-data/former-customer/correction-request-information"
                  component={
                    props => (
                      <FormerCustomerCorrectionRequestInformation
                        {...props}
                        isNonSecure
                      />
                    )
                  }
                />

                <Route
                  exact
                  path="/privacy/your-data/former-customer/your-correctible"
                  component={
                    props => (
                      <CorrectibleData
                        {...props}
                        isNonSecure
                        pageContentUrl={ENDPOINTS.FETCH_FORMER_CUSTOMER_LANDING}
                      />
                    )
                  }
                />
                {/* END OF 22.14 FETCH_FORMER_CUSTOMER_CORRECTIBLE_PAGES */}

                {/* 22.16.1 */}
                <Route
                  exact
                  path="/privacy/your-data/former-customer/your-deletable"
                  component={
                    props => (
                      <FormerCustomerDeleteInformation
                        {...props}
                        isNonSecure
                        skipVerification
                        pageContentUrl={ENDPOINTS.FETCH_FORMER_CUSTOMER_DELETE_PAGES}
                      />
                    )
                  }
                />

                < Route
                  exact
                  path="/privacy/your-data/former-customer/delete-confirmation"
                  component={
                    props => (
                      <FormerCustomerDeleteConfirmation
                        {...props}
                        isNonSecure
                        skipVerification
                      />
                    )
                  }
                />
                {/* END OF 22.16.1 FETCH_FORMER_CUSTOMER_DELETABLE_PAGES */}

                <Route path="/privacy/secure/retrieval-password" exact component={DownloadPasswordPage} />
                <Route path="/privacy/secure/request-history" exact component={RequestHistory} />
                <Route path="/privacy/secure/download-status" exact component={DownloadStatus} />
                <Route path="/privacy/secure/review-download" exact component={ConfirmAuth(ReviewDownload)} />
                <Route path="/privacy/secure/download-amount" exact component={ConfirmAuth(DownloadAmount)} />
                <Route path="/privacy/secure/affidavit-primer" exact component={ConfirmAuth(AffidavitPrimer)} />
                <Route path="/privacy/secure/affidavit-confirmation" exact component={ConfirmAuth(AffidavitConfirmation)} />
                <Route path="/privacy/secure/device-selection" exact component={ConfirmAuth(DeviceSelection)} />
                <Route path="/privacy/secure/multifactor-authentication-primer" exact component={ConfirmAuth(MultifactorAuthenticationPrimer)} />
                <Route path="/privacy/secure/multifactor-authentication" exact component={ConfirmAuth(MultifactorAuthentication)} />
                <Route path="/privacy/secure/file-format-selection" exact component={ConfirmAuth(FileFormatSelection)} />
                <Route path="/privacy/secure/delete" exact component={DeleteInformation} />
                <Route path="/privacy/secure/delete-member" exact component={DeleteInformationMember} />
                <Route path="/privacy/secure/delete-line-selection" exact component={ConfirmAuth(DeleteLineSelection)} />
                <Route path="/privacy/secure/delete-request-success" exact component={ConfirmAuth(DeleteSuccess)} />
                <Route path="/privacy/secure/delete-review" exact component={ConfirmAuth(DeleteReview)} />
                <Route path="/privacy/your-data/guest/review" exact component={DeleteReview} />
                <Route exact path="/privacy/secure/submit-appeal" component={SubmitAppeal} />
                <Route exact path="/privacy/secure/submit-proof" component={
                    props => <SubmitProof {...props} />
                  } />
                <Route exact path="/privacy/secure/appeal-confirmation" component={AppealConfirmation} />
                <Route exact path="/privacy/secure/appeal-status" component={AppealStatus} />
                

                <Route exact path="/privacy/secure/correction-status" component={CorrectionStatus} />
                <Route
                  path="/privacy/secure/request-download"
                  exact
                  component={
                    checkAMLob() === "autoapp" || checkAMLob() === "ip" ? ConfirmAuth(CVASelectDownloadCategories):ConfirmAuth(SelectDownloadCategories)
                  }/>

                <Route
                  exact
                  path="/privacy/secure/your-correctible"
                  component={
                    props => {
                      let url = "";
                      if (checkAMLob() === "vzw") {
                        url = ENDPOINTS.FETCH_WIRELESS_LANDING_PAGE;
                      }
                      else if (checkAMLob() === "vzt") {
                        url = ENDPOINTS.FETCH_WIRELINE_LANDING_PAGE;
                      }
                      else {
                        //let it default to wireless.
                        url = ENDPOINTS.FETCH_WIRELESS_LANDING_PAGE;
                      }
                      return (
                        <CorrectibleData {...props} pageContentUrl={url} />
                      )
                    }
                  }
                />

              {/* Connected Vehicles*/}

              {/*Connected Vehicles */}
                

                <Route
                  exact
                  path="/privacy/secure/authorized-agent"
                  component={
                    props => <AuthorizedAgentLanding {...props} pageContentUrl={ENDPOINTS.FETCH_AUTHORIZED_AGENT_LANDING_PAGE} />
                  }
                />

                <Route
                  exact
                  path="/privacy/secure/your-data/authorized-agent/information"
                  component={
                    props => {
                      let url = "";
                      if (checkAMLob() === "vzt") {
                        url = ENDPOINTS.FETCH_ASSIGN_AUTHORIZED_AGENT_WIRELINE_PAGE;
                      } else if (checkAMLob() === "ott" || checkAMLob() === "nico" || checkAMLob() === "vils" || checkAMLob()=== "autoapp" || checkAMLob() === "ip") {
                        url = ENDPOINTS.FETCH_ASSIGN_AUTHORIZED_AGENT_OTT_PAGE;
                      } else {
                        url = ENDPOINTS.FETCH_ASSIGN_AUTHORIZED_AGENT_WIRELESS_PAGE;
                      }

                      return (
                        <AssignAgentInformation {...props} pageContentUrl={url} />
                      )
                    }
                  }
                />

                <Route exact path="/privacy/secure/authorized-agent/delete" component={
                  props => <AuthorizedAgentDeleteInformation {...props} pageContentUrl={ENDPOINTS.FETCH_AUTHORIZED_AGENT_DELETE_PAGE} />
                }
                />

                <Route exact path="/privacy/secure/authorized-agent/download" component={
                  props => <AuthorizedAgentDownloadInformation {...props} pageContentUrl={ENDPOINTS.FETCH_AUTHORIZED_AGENT_DOWNLOAD_PAGES} />
                }
                />
                {/* 22.15.1 */}
                <Route exact path="/privacy/secure/authorized-agent/correction" component={
                  props => <CorrectibleData {...props} pageContentUrl={ENDPOINTS.FETCH_AUTHORIZED_AGENT_CORRECTIBLE} />
                }
                />
                {/* end of 22.15.1 */}

                <Route path="/privacy/secure/authorized-agent/download-amount"
                  exact
                  component={ConfirmAuth(DownloadAmount)}
                />
                {/* new add  */}
                <Route path="/privacy/secure/authorized-agent/request-download"
                  exact 
                  component={ConfirmAuth(AuthorizedAgentRequestDownload)}
                />
                {/* New Add */}
                <Route path="/privacy/secure/authorized-agent/file-format-selection" 
                  exact 
                  component={ConfirmAuth(AuthorizedAgentFileFormat)} />

                <Route exact path="/privacy/secure/authorized-agent/customer/status" component={
                  props => <AgentCustomerDownloadStatus {...props} pageContentUrl={ENDPOINTS.FETCH_AUTHORIZED_AGENT_DOWNLOAD_STATUS_PAGES} />
                }
                />

                <Route exact path="/privacy/secure/authorized-agent/customer/download-password" component={
                  props => <CustomerDownloadPasswordPage {...props} />
                }
                />

                <Route path="/privacy/secure/authorized-agent/multifactor-authentication-primer"
                  exact
                  component={ConfirmAuth(MultifactorAuthenticationPrimer)}
                />

                <Route path="/privacy/secure/authorized-agent/multifactor-authentication"
                  exact
                  component={ConfirmAuth(MultifactorAuthentication)}
                />

                <Route exact path="/privacy/secure/your-data/authorized-agent/assign" component={AssignAuthorizedAgent} />
                <Route exact path="/privacy/secure/your-data/authorized-agent/manage" component={ManageAuthorizedAgent} />
                <Route exact path="/privacy/secure/your-data/authorized-agent/review" component={AuthorizedAgentReview} />
                <Route exact path="/privacy/secure/your-data/authorized-agent/submit-success" component={AuthorizedAgentSubmitSuccess} />
                <Route exact path="/privacy/secure/your-data/authorized-agent/success" component={RenewRemoveAuthAgentSuccess} />
                <Route exact path="/privacy/secure/authorized-agent/new-request" component={AuthorizedAgentNewRequest} />
                <Route exact path="/privacy/secure/authorized-agent/download/affidavit" component={AuthorizedAgentDownloadAffidavit} />
                <Route exact path="/privacy/secure/authorized-agent/download/affidavit-primer" component={AuthorizedAgentAffidavitPrimer}/>
                <Route exact path="/privacy/secure/authorized-agent/download/review" component={AuthorizedAgentDownloadReview} />
                <Route exact path="/privacy/secure/authorized-agent/download/success" component={AuthorizedAgentDownloadSuccess} />
                <Route exact path="/privacy/secure/authorized-agent/delete/review" component={AuthorizedAgentDeleteReview} />
                <Route exact path="/privacy/secure/authorized-agent/delete/success" component={AuthorizedAgentDeleteSuccess} />
                <Route exact path="/privacy/secure/authorized-agent/customer" component={AuthorizedAgentCustomer} />
                <Route exact path="/privacy/secure/authorized-agent/customer/submit-appeal" component={AuthorizedAgentSubmitAppeal} />
                <Route exact path="/privacy/secure/authorized-agent/customer/submit-proof" component={
                    props => <AuthorizedAgentSubmitProof {...props} />
                  } />
                <Route exact path="/privacy/secure/authorized-agent/customer/appeal-status" component={AuthorizedAgentAppealStatus} />
                <Route exact path="/privacy/secure/authorized-agent/customer/appeal-confirmation" component={AuthorizedAgentAppealConfirmation} />
                <Route exact path="/privacy/secure/authorized-agent/customer/correct-status" component={AuthorizedAgentCorrectStatus} />

                <Route
                  path="/privacy/secure/download-information"
                  exact
                  component={() => LobWrapper(
                    DownloadInformation,
                    WirelineDownloadInformation,
                    OTTDownloadInformation,
                    () => (
                      <FamilyMoneyDownloadInformation
                        {...props}
                        history={history}
                        pageContentUrl={ENDPOINTS.FETCH_FAMILY_MONEY_DOWNLOAD_PAGES}
                      />
                    ),
                    () => (
                      <VILSDownloadInformation
                        {...props}
                        history={history}
                        pageContentUrl={ENDPOINTS.FETCH_VILS_DOWNLOAD_PAGES}
                      />
                    ),
                    () => (
                      <CVADownloadInformation
                        {...props}
                        history={history}
                      />
                    ),
                    () => (
                      <FamilyAppDownloadInformation
                        {...props}
                        history={history}
                      />
                    )
                  )}
                />

                <Route
                  path="/privacy/secure/your-data"
                  exact
                  component={() => LobWrapper(
                    // () => <LoggedInLanding {...props} pageContentUrl={ENDPOINTS.FETCH_WIRELESS_LANDING_PAGE} />,
                    LoggedInLanding,
                    WirelineLanding,
                    () => <OTTLanding {...props} pageContentUrl={ENDPOINTS.FETCH_OTT_LANDING_PAGE} />,
                    () => <FamilyMoneyLandingPage {...props} pageContentUrl={ENDPOINTS.FETCH_FAMILY_MONEY_LANDING_PAGE} />,
                    () => <VILSLandingPage {...props} pageContentUrl={ENDPOINTS.FETCH_VILS_LANDING_PAGE} />,
                    () => <CVALanding {...props} pageContentUrl={ENDPOINTS.FETCH_CVA_LANDING_PAGE} />,      //Added by arvind
                    () => <FamilyAppLanding {...props} pageContentUrl={ENDPOINTS.FETCH_CVA_LANDING_PAGE} />   // Added by arvind

                  )}
                />

                <Route path="/privacy/secure/resend-password-success" exact component={ResendPasswordSuccess} />
                <Route path="/privacy/secure/email-not-verified" exact component={EmailNotVerified} />
                <Route path="/privacy/secure/sms-not-verified" exact component={SMSNotVerified} />
                <Route path="/privacy/secure/mtn-not-verified" exact component={MTNNotVerified} />
                <Route path="/privacy/secure/action-needed" exact component={ActionNeeded} />
                <Route path="/privacy/secure/marketing-preferences" exact component={MarketingPreferences} />

                <Route
                  path="/privacy/secure/accountdisconnected"
                  exact
                  component={() =>
                    <AccountDisconnected
                      {...props}
                      isNonSecure
                      pageContentUrl={ENDPOINTS.FETCH_ACCOUNT_DISCONNECTED_PAGE}
                    />
                  }
                />

                <Route path="/privacy/secure/disconnected" exact component={DisconnectedCustomer} />
                <Route path="/privacy/secure/account-not-supported" exact component={AccountNotSupported} />
                <Route path="/privacy/secure/wireline-sub-account" exact component={WirelineSubAccount} />
                <Route path="/privacy/secure/be-unauthorized" exact component={BECustomer} />

                <Route
                  exact
                  isNonSecure
                  path="/privacy/your-data/guest-landing"
                  component={GuestFlowLandingNew}
                />

                <Route path="/privacy/your-data/guest/download" exact component={DownloadStatus} />

                <Route path="/privacy/your-data/guest-download/" exact component={
                  props => <DownloadStatus {...props} />
                } />

                <Route path="/privacy/your-data/guest/affidavit" exact component={AffidavitConfirmation} />
                <Route path="/privacy/your-data/guest/delete" exact component={GuestFlowDeleteInfo} />
                <Route path="/privacy/your-data/guest/download-information" exact component={GuestFlowDownloadInformation} />
                <Route path="/privacy/your-data/guest/multifactor-authentication-primer" exact component={ConfirmAuth(MultifactorAuthenticationPrimer)} />
                <Route path="/privacy/your-data/guest/multifactor-authentication" exact component={ConfirmAuth(MultifactorAuthentication)} />
                <Route path="/privacy/your-data/guest/resend-password-success" exact component={ResendPasswordSuccess} />
                <Route path="/privacy/your-data/guest-download/multifactor-authentication-primer" exact component={ConfirmAuth(MultifactorAuthenticationPrimer)} />
                <Route path="/privacy/your-data/guest-download/multifactor-authentication" exact component={ConfirmAuth(MultifactorAuthentication)} />
                <Route path="/privacy/your-data/guest-download/resend-password-success" exact component={ResendPasswordSuccess} />
                <Route path="/privacy/your-data" exact component={UniversalLanding} />
                <Route path="/privacy/your-data/login" exact component={LoginPage} />
                <Route path="/" exact component={() => <Redirect to="/privacy/your-data" />} />

                <Route path="/privacy/your-data/guest-download/"
                  component={
                    CommonDownloadWrapper(
                      DownloadEmailAuthentication,
                      DownloadOTPAuthentication,
                      DownloadPasswordPage,
                      DownloadVerification
                    )
                  }
                />

                <Route exact path="/privacy/your-data/submit-appeal" component={FormerAndGuestSubmitAppeal} />
                <Route exact path="/privacy/your-data/appeal-status" component={FormerAndGuestAppealStatus} />
                <Route exact path="/privacy/your-data/appeal-confirmation" component={FormerAndGuestAppealConfirmation} />
                <Route component={NoMatch} />

              </Switch>
            </div>
          </ErrorBoundary>
        </ScrollToTop>
      </Router>
    </BrowserRouter>
  );
};

export default Layout;
